// src/components/AboutUsPage.js
import React from "react";
import { Helmet } from "react-helmet-async";
import Header from "./Header";
import Footer from "./Footer";
import "./AboutUsPage.css";

function AboutUsPage() {
  return (
    <>
      <Helmet>
        <title>O nama | Sezonski Poslovi Star</title>
        <meta
          name="description"
          content="Sezonski Poslovi Star povezuje kandidate sa poslodavcima u Hrvatskoj i Crnoj Gori. Naša misija je da olakšamo pronalazak posla i unaprijedimo tržište rada."
        />
      </Helmet>

      <Header />

      <section className="about-section">
        <div className="about-container">
          <h1 className="about-title">O nama</h1>
<p className="about-text">
  Dobrodošli na <strong>Sezonski Poslovi Star</strong> — platformu posvećenu
  povezivanju radnika i poslodavaca u Hrvatskoj i Crnoj Gori. Naša misija je da
  proces zapošljavanja učinimo <em>jednostavnim, brzim i transparentnim</em>,
  kako za kandidate, tako i za kompanije koje traže pouzdane radnike.
</p>

<p className="about-text">
  Sa velikim brojem stalnih i sezonskih oglasa, nudimo svima priliku da pronađu
  posao koji odgovara njihovim vještinama i ambicijama. Kandidati mogu
  pretraživati oglase po lokaciji i poziciji, provjeriti uslove smještaja i
  obroka, te aplicirati online u samo nekoliko minuta. Na ovaj način štedimo
  vaše vrijeme i pomažemo da se brže dođe do sigurnog zaposlenja.
</p>

<p className="about-text">
  Naš tim svakodnevno radi na tome da oglasi budu ažurni, provjereni i jasni.
  Poslodavcima nudimo priliku da predstave svoje kompanije i pronađu radnike
  koji zaista odgovaraju njihovim potrebama, dok kandidatima nudimo sigurnost i
  pouzdane informacije prije nego što se odluče za prijavu.
</p>

<p className="about-text">
  Vjerujemo da je <strong>uspjeh svakog posla u ljudima</strong>. Zato našu
  platformu gradimo kao most između poslodavaca i kandidata, gdje je svaka
  saradnja zasnovana na povjerenju, jasnoj komunikaciji i obostranom
  zadovoljstvu. Cilj nam je da doprinesemo zdravijem tržištu rada i da
  unaprijedimo iskustvo zapošljavanja u regionu.
</p>

<p className="about-text">
  Bez obzira da li ste student koji traži sezonski posao, iskusni profesionalac
  koji želi stalno zaposlenje ili kompanija koja traži nove članove tima —
  <strong>Sezonski Poslovi Star</strong> je pravo mjesto za vas.
</p>

        </div>
      </section>

      <Footer />
    </>
  );
}

export default AboutUsPage;
